import script from "./exampleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./exampleTable.vue?vue&type=script&setup=true&lang=js"

import "./exampleTable.vue?vue&type=style&index=0&id=27563aba&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27563aba"]])

export default __exports__